import apiClient from './api';
import authStore from '@/store/auth';

export const aiInstructionsService = {
  // Get saved AI instructions from API
  async getSavedInstructions() {
    try {
      
      // Check authentication first
      if (!authStore.state.isLoggedIn) {
        return '';
      }
      
      // Use axios client to get instructions
      const response = await apiClient.get('/ai-instructions/');
      
      if (response.data && 'instructions' in response.data) {
        return response.data.instructions || '';
      } else {
        return '';
      }
    } catch (error) {
      console.error('Error fetching AI instructions from API:', error);
      // Show more details about the error
      if (error.response) {
        console.error('Error response:', error.response.status, error.response.data);
      }
      return '';
    }
  },

  // Save AI instructions to API
  async saveInstructions(instructions) {
    try {
      
      // Check authentication first
      if (!authStore.state.isLoggedIn) {
        return {
          success: false,
          source: 'none',
          message: 'Not logged in'
        };
      }
      
      // Get user information
      const userId = authStore.state.user?.id;
      
      if (!userId) {
        return {
          success: false,
          source: 'none',
          message: 'No user ID available'
        };
      }
      
      // First check if we need to update or create
      try {
        const checkResponse = await apiClient.get('/ai-instructions/');
        
        if (checkResponse.data && checkResponse.data.id) {
          // Update existing instructions
          const id = checkResponse.data.id;
          
          const updateResponse = await apiClient.patch(`/ai-instructions/${id}/`, {
            instructions: instructions
          });
          
          
          return {
            success: true,
            data: updateResponse.data,
            source: 'database'
          };
        }
      } catch (error) {
        // Continue with create logic
      }
      
      // Create new instructions
      
      // Make a direct Axios request with explicit user ID
      // Use both user and user_id to ensure at least one works
      const createData = {
        user: userId,
        user_id: userId,
        instructions: instructions
      };
      
      
      const createResponse = await apiClient.post('/ai-instructions/', createData);
      
      return {
        success: true,
        data: createResponse.data,
        source: 'database'
      };
    } catch (error) {
      console.error('Error saving AI instructions to API:', error);
      
      // Log detailed error information
      if (error.response) {
        console.error('Error response status:', error.response.status);
        console.error('Error response data:', error.response.data);
        console.error('Error response headers:', error.response.headers);
      } else if (error.request) {
        console.error('Error request:', error.request);
      } else {
        console.error('Error message:', error.message);
      }
      
      return {
        success: false,
        error: error,
        source: 'none',
        message: error.response?.data?.error ||
                 error.response?.data?.detail ||
                 error.response?.data?.user?.[0] ||
                 'Failed to save instructions'
      };
    }
  },

  // Ask the AI to draft a full instruction template for the active profile.
  // Throttled server-side (5/day) — callers should handle a 429 response.
  // Returns the raw axios response so callers can read res.data.instructions
  // and inspect error status codes (e.g. 429) themselves.
  async generateInstructions() {
    return apiClient.post('/ai-instructions/generate-instructions/');
  }
};

export default aiInstructionsService; 